module.exports = __webpack_public_path__ + "static/madsallygames-logo-f6227c1fb1c6380903b81eefdaac9d32.png";